import ScrollReveal from 'scrollreveal';

ScrollReveal({
  distance: '60px',
  // rotate: { z: 10 },
  viewFactor: 0.2,
  mobile: false
}).reveal('section')